<template>
  <div class="guide-page">
    <iframe
      title="Panduan Lengkap Medhop"
      src="/guide/index.html"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "MedhopUserGuide",
};
</script>

<style scoped>
.guide-page {
  height: calc(100vh - 122px);
  min-height: 680px;
  overflow: hidden;
  border: 1px solid #dfe8e5;
  border-radius: 14px;
  background: #f6f8f6;
}

.guide-page iframe {
  display: block;
  width: 100%;
  height: 100%;
}

@media (max-width: 767px) {
  .guide-page {
    height: calc(100vh - 92px);
    min-height: 560px;
    border-radius: 10px;
  }
}
</style>
